import { ICellRendererParams } from '@ag-grid-community/core';
import { ColDef } from '@ag-grid-community/core';
import { getMyUser } from './api/users';

const userRenderer = (name: string, url: string, avatar: string) => {
  if (!name) {
    return '';
  }
  if (!url) {
    return name;
  }

  return (
    <a className="issue__assignee" href={url} target="_blank" rel="noreferrer">
      <img src={avatar} />
      <span>{name}</span>
    </a>
  );
};

const getAllUsers = (api: any) => {
  const allUsers: any[] = [getMyUser()];
  const idMap: { [key: string]: boolean } = {};
  api?.forEachNode((rowNode: any) => {
    const data = rowNode?.data;
    const login = data?.['user:login'];
    if (login && !idMap[login]) {
      const user = {
        login,
        html_url: data?.['user:html_url'],
        avatar_url: data?.['user:avatar_url'],
      };
      idMap[login] = true;
      allUsers.push(user);
    }
  });
  return allUsers;
};

export const columnDefs: ColDef[] = [
  {
    headerName: 'Id',
    field: 'id',
    type: 'abColDefNumber',
    colId: 'id',
    width: 120,
    cellRenderer: ({ value, data }: ICellRendererParams) => {
      return data ? (
        <a
          className="issue__id"
          href={data?.html_url}
          target="_blank"
          rel="noreferrer"
        >
          {value}
        </a>
      ) : (
        ''
      );
    },
  },
  {
    headerName: 'Title',
    field: 'title',
    type: 'abColDefString',
    colId: 'title',
    wrapText: true,
    autoHeight: false,
    width: 280,
    cellRenderer: ({ value }: ICellRendererParams) => {
      if (!value) {
        return '';
      }
      return <span className="issue__title">{value}</span>;
    },
  },
  {
    headerName: 'Labels',
    field: 'labels',
    filter: false,
    floatingFilter: false,
    valueGetter: ({ data }) =>
      data?.labels?.map((label: { name: string }) => label?.name)?.join(', '),
    cellRenderer: ({ data }: ICellRendererParams) => {
      if (!data?.labels || !Array.isArray(data?.labels)) {
        return '';
      }
      return (
        <>
          {data?.labels?.map((label: { name: string }) => (
            <span key={label.name} className="issue__tag">
              {label.name}
            </span>
          ))}
        </>
      );
    },
  },
  {
    headerName: 'Author',
    field: 'user:login',
    type: 'abColDefString',
    colId: 'user:login',
    width: 130,
    cellRenderer: ({ data, value }: ICellRendererParams) =>
      userRenderer(value, data?.['user:html_url'], data?.['user:avatar_url']),
  },
  {
    headerName: 'Assigned To',
    field: 'assignee:login',
    width: 130,
    colId: 'assignee:login',
    cellEditor: 'agRichSelectCellEditor',
    cellEditorPopup: true,
    editable: true,
    cellRenderer: (params: ICellRendererParams) => {
      const { value } = params;
      const user = getAllUsers(params.api).find((user) => user.login === value);
      return userRenderer(value, user?.['html_url'], user?.['avatar_url']);
    },
  },
  {
    headerName: 'Created At',
    field: 'created_at',
    type: 'abColDefDate',
    colId: 'created_at',
    width: 120,
  },
  {
    headerName: 'Updated At',
    field: 'updated_at',
    type: 'abColDefDate',
    colId: 'updated_at',
    width: 120,
    editable: true,
  },
  {
    headerName: 'Closed At',
    field: 'closed_at',
    type: 'abColDefDate',
    colId: 'closed_at',
  },

  {
    headerName: 'State',
    field: 'state',
    type: 'abColDefString',
    colId: 'state',
    width: 100,
    editable: true,
  },

  {
    headerName: 'Locked',
    field: 'locked',
    type: 'abColDefBoolean',
    colId: 'locked',
    maxWidth: 120,
    editable: true,
  },

  {
    headerName: 'Milestone',
    field: 'milestone',
    type: 'abColDefString',
    colId: 'milestone',
    editable: true,
  },

  {
    headerName: 'Comments',
    field: 'comments',
    type: 'abColDefNumber',
    colId: 'comments',
    width: 130,
    aggFunc: 'sum',
  },

  {
    headerName: 'Body',
    field: 'body',
    type: 'abColDefString',
    colId: 'body',
    editable: true,
  },
  {
    headerName: '👍 👎',
    field: 'reactions',
    type: 'abColDefNumber',
    width: 120,
    cellRenderer: ({ value }: ICellRendererParams) => {
      if (!value) {
        return `👍 0`;
      }
      if (value >= 0) {
        return `👍 ${value}`;
      } else {
        return `👎 ${value}`;
      }
    },
    editable: true,
    aggFunc: 'sum',
  },
];
